import { StyledDiv } from "views/Admin/subviews/FooterLinks/FooterLinks.styles";
import { useTranslation } from "react-i18next";

export default function Privacy2() {
  const { t } = useTranslation();
  // Text has been coded for automatic translation using i18nexus. Nameing conventions for this will be as follows:
  // u-(text)-(text) is for words that all start with a capital letter ie. u-happy-feelings = Happy Feelings
  // s-(text)-(text)-(number) is for a sentence or paragraph that needs indexing. On this page the naming convention is different because there are multiple paragraphs one after another that need an index.
  // The naming convention can be read as follows: s(sentence/paragraph)-h(heading) or l(list item) or p(paragraph)-pp(privacy policy)-1(index)

  return (
    <StyledDiv>
      <h1>Life365 Privacy Policy</h1>
      <h2>LAST UPDATED: JANUARY 1, 2023</h2>
      <p>
        ​Life365, Inc. and its subsidiaries (or affliations), Life365 Health,
        LLC, Life365.MyShopify.com, LifeConnect, LLC, L365 Labs and Website
        (“Life365,” "Life365.Health," "Life365.MyShopify," "LifeConnect,"
        "Life365 Labs," “we,” “our,” or “us”) Privacy Statement — Highlights
      </p>
      <p>
        ​Here at Life365, we know how much you value privacy, and we realize
        that you care about what happens to the information you provide to us
        through our website, mobile application, live events, and other sources
        (our “Website”). We have provided highlights below regarding how we
        collect, use, and share your information. Click here to see our full
        Privacy Statement. Note that this Privacy Statement does not apply to
        information collected through the Life365 Portals, which has a separate
        Privacy Statement available at
        https://www.life365.health/portal-registration
      </p>
      <p>
        ​If you are a California resident, click here for information about Your
        California Privacy Rights.
      </p>
      <br />
      <h3>What Information Does Life365 Collect?</h3>
      <p>We collect the following types of information:</p>
      <ul>
        <li>
          Contact information (such as name, address, city, state, zip code,
          email address, and telephone number)
        </li>
        <li>
          Information that you choose to provide, such as when registering on
          the Website or signing up for promotions (such as your birth date,
          household information, income, marital status, and education)
        </li>
        <li>
          Product preferences, advertisement preferences, and other information
          about how you use our Website
        </li>
        <li>
          Content you submit or post (such as photographs, videos, reviews,
          articles, comments, or any other information you provide to us or
          post)
        </li>
        <li>
          Financial and payment information (such as payment card number,
          expiration date, account number, and billing address)
        </li>
        <li>Employment and employment application information</li>
        <li>
          Information automatically collected about your interactions with our
          Website, such as your browser information or IP address. If you access
          our Website from a mobile device, we may collect data about your
          device.
        </li>
        <li>
          Geolocation Information: We may also collect your precise location
          using GPS, cell tower, Bluetooth, or WiFi signals if you access our
          Website from a mobile device. You may turn this feature off at any
          time in your device settings.
        </li>
      </ul>
      <br />
      <p>
        This information is collected from a variety of sources including
        information that you give us directly (for example during product
        purchases and when you post information on the Website), information
        that we receive from affiliates and other third party sources, and
        information automatically collected when you visit our Website (such as
        via cookies or web beacons).
      </p>
      <p>Read more about the information we collect </p>
      <br />
      <h3>How Does Life365 Use My Information?</h3>
      <p>​We use your information for the following purposes:</p>
      <br />
      <ul>
        <li>
          establishing and verifying the identity and eligibility of users;
        </li>
        <li>
          opening, maintaining, administering, managing, and servicing users
          profiles, accounts or memberships;
        </li>
        <li>
          processing, servicing or enforcing transactions (such as credit or
          debit card transactions or gift card transactions);
        </li>
        <li>
          providing products, content, content suggestions, services, and
          support;
        </li>
        <li>
          conducting special events, sweepstakes, surveys, programs, contests,
          and other offers (and communicating with you about such events);
        </li>
        <li>
          analyzing and improving our products, services, or Website (including
          developing new products and services; improving safety; managing our
          communications; analyzing our products; performing market research;
          performing data analytics; and performing accounting, auditing and
          other internal functions);
        </li>
        <li>providing users with product, service, or company updates;</li>
        <li>
          marketing and advertising our products or services as well as products
          and services of third parties (such as affiliates, subsidiaries, and
          business partners);
        </li>
        <li>
          responding to your inquiries or comments, or contacting you as
          necessary;
        </li>
        <li>
          operating and communicating with you about or through external social
          networking platforms;
        </li>
        <li>
          maintaining the security and integrity of our systems, including
          maintaining internal records;
        </li>
        <li>
          conforming to legal requirements or industry standards, complying with
          legal process, detecting and preventing fraud or misuse, defending our
          legal rights, or protecting others; and
        </li>
        <li>
          as part of a merger, acquisition, bankruptcy, transfer, sale,
          corporate change, or any other transaction involving all or a portion
          of Life365’s assets
        </li>
      </ul>
      <br />
      <p>
        ​All information we collect may be aggregated and merged or enhanced
        with data from other sources, such as third parties or our mobile
        application.{" "}
      </p>
      <p>​Read more about how we use your information</p>
      <br />
      <h3>How Does Life365 Share My Information?</h3>
      <p>We share your information as follows:</p>
      <br />
      <ul>
        <li>
          With third party service providers or business partners who help us
          with our business functions
        </li>
        <li>
          With affiliated companies and non-affiliated business partners for our
          or the third party’s marketing purposes
        </li>
        <li>
          With other Website users when you post or share information publicly
        </li>
        <li>
          If necessary to protect the safety, property, or other rights of us,
          our users, or employees, or when required by law
        </li>
        <li>With your consent</li>
        <li>
          If the ownership or control of the Websites or its assets changes, we
          may transfer your information to the new owner
        </li>
      </ul>
      <br />
      <p>Read more about how we share your information</p>
      <br />
      <h3>Life365 Website Privacy Statement — Full Statement</h3>
      <p>
        ​Life365, Inc. and its subsidiaries, Life365 Health, LLC, LifeConnect,
        LLC, Life365 Labs, LLC and HealtheLife, LLC Website (“Life365,”
        "Life365.Health," "LifeConnect," "Life365 Labs," "HealtheLife," “we,”
        “our,” or “us”) respects your concerns about privacy and values the
        relationship we have with you. This Privacy Statement describes the
        types of information we collect about you, how we use the information,
        with whom we share it, the choices available to you regarding our use of
        the information, and how you can contact us about our privacy practices.
      </p>
      <br />
      <h3>1. What Information Does This Privacy Statement Apply to?</h3>
      <p>
        ​This Privacy Statement applies to the collection, use, and disclosure
        of information from and about you by Life365 on Life365's websites
        (https://www.life365.health), through our mobile application, and
        through telephone, email communications, and other sources
        (collectively, our “Website”). Life365’s mobile applications will
        collect the same information identified in this Privacy Statement and
        that information will be used and shared as stated in this Privacy
        Statement.
      </p>
      <p>
        ​This Privacy Statement does not apply to information collected via
        MyLife365 Applications / Portals nor to third party websites that may be
        accessible through hyperlinks on the Website, which have their own
        privacy statement that we encourage you to review. Linking to a third
        party site does not mean that we endorse the site, any products or
        services described on the site, or any other material contained in a
        third party site. To the extent any linked websites you visit are not
        owned or controlled by us, we are not responsible for the sites’
        content, any use of the sites, or the privacy practices of the sites.
        Please review the privacy statement on those other websites to see how
        they handle your information.
      </p>
      <p>
        ​If you choose to use our Website in any way, such as browsing or
        interacting, you agree with the terms of our current Privacy Statement
        as posted here. If you do not agree with this Privacy Statement, you
        should not use our Website. We may update or modify this Privacy
        Statement from time to time at our sole discretion, and will note the
        date of last update on the top of this page. We encourage you to visit
        this area frequently to stay informed, as your continued use of our
        Website following the posting of changes to these terms means that you
        consent to such changes.
      </p>
      <br />
      <h3>​2. What Information Does Life365 Collect?</h3>
      <p>
        We may obtain information about you from various sources. We may collect
        this information when you provide it on our website, mobile application,
        external social media platforms, in telephone or email communication, in
        connection with social networking, or at one of our events. When you
        visit the Website, we may also collect certain information about your
        device or usage by automated means or by using technologies such as
        cookies, web server logs, and web beacons.
      </p>
      <h3>​Information that You or Others Provide</h3>
      <p>
        ​You may choose to provide information to us in a number of ways, such
        as when you purchase our products, sign up to receive our newsletter,
        participate in an offer or promotion, when you register on the Website,
        when you post or provide content, when you contact us, or when you
        otherwise interact on the Website. The types of information you may
        provide to us include:
      </p>
      <br />
      <ul>
        <li>
          Contact information (such as name, address, city, state, ZIP code,
          email address and telephone number)
        </li>
        <li>
          Information that you choose to provide, such as when signing up for
          promotions or newsletters (including your birth date, household
          information, income, marital status, and education)
        </li>
        <li>
          Product preferences, advertisement preferences, and other information
          about how you use our Website
        </li>
        <li>
          Content you submit or post (such as photographs, videos, reviews,
          articles, comments, or any other information you provide to us or
          post)
        </li>
        <li>
          Financial and payment information (such as payment card number,
          expiration date, account number, and billing address)
        </li>
        <li>Employment and employment application information</li>
      </ul>
      <br />
      <p>
        ​If you provide us with information regarding another individual, we
        will assume that you have that person’s consent to give us his or her
        information.
      </p>
      <p>
        ​In addition, we may collect information about you that is provided to
        us by other Website users and other third parties as well as from
        external social networks (such as your name, profile picture, likes,
        location, and friend list).
      </p>
      <h3>​Information Collected Automatically</h3>
      <p>
        ​When you visit this Website or our online advertisements, utilize our
        services, open an email that we send you, or interact with social
        networking applications, we may collect information about your usage or
        device by automated means or by using technologies such as cookies, web
        server logs, and web beacons. As set forth in more detail below, we may
        also collect information about your usage and browsing habits using
        various web-based technologies.
      </p>
      <br />
      <ul>
        <li>
          Cookies: Cookies are small text files that websites send to your
          computer or other Internet-connected device to uniquely identify your
          browser or to store information or settings in your browser. Your
          browser may tell you how to be notified when you receive certain types
          of cookies and how to restrict or disable certain cookies. Some
          cookies may exist for only a single session and some are persistent
          for multiple sessions over time. We may use cookies that are managed
          by Life365 or by third parties for the purposes provided in this
          Privacy Statement, including for session management, authentication,
          user preference storage, Website performance and personalization,
          Website analytics, advertising (including affiliate marketing),
          content management, eCommerce, search, and social media integration.
        </li>
        <li>
          Web server logs: In conjunction with obtaining information through
          cookies, our web servers may log details regarding your device,
          operating system, or information about your Website usage.
        </li>
        <li>
          Web beacons & pixels: To control which web servers collect information
          described above, we may place tags on our Website or in emails called
          “web beacons” or “pixels.” These are computer instructions that link
          web pages to particular web servers and their cookies. Web beacons and
          pixels can be used to track the pages you view, links that you click,
          or other online behavior. These tools may also be used to measure the
          effectiveness of our email campaigns by identifying the individuals
          who open or act upon an email message, when an email message is
          opened, how many times an email message is forwarded, the type of
          software, device, operating system and browser used to deliver the
          email, and any URL accessed through our email message. Such tools are
          also used in connection with online advertisements on our Website and
          on third party websites to collect the same types of information with
          respect to individuals who click on advertisements.
        </li>
        <li>
          Other: we may use other technology to collect information for the
          purposes described in this Privacy Statement.
        </li>
      </ul>
      <br />
      <p>
        ​Such technologies may permit collection of data elements such as
        demographic data, browser type, MAC address and other device
        information, operating system type and settings, domain, the address of
        the web page that linked you to our Website, IP address, pages visited,
        whether you have visited us before or are new to the Website, activities
        conducted on the page (such as search queries), and the day and time of
        your visit.
      </p>
      <p>
        ​If you access our Websites from a mobile device, we may collect your
        precise location using GPS, cell tower, Bluetooth, or WiFi signals. You
        may turn this feature off in your device settings at any time.
      </p>
      <p>
        At this time, we do not honor “do not track” signals from website
        browsers. However, you may refuse or delete cookies. If you refuse or
        delete cookies, some of the functionality of our Websites may be
        impaired. If you turn off cookies, Web beacon and other technologies
        will still detect visits to our Websites, but the information they
        generate cannot be associated with other non-identifiable cookie
        information and are disregarded. Please refer to your browser Help
        instructions to learn more about how to manage cookies and the use of
        similar technologies.
      </p>
      <br />
      <h3>3. How Does Life365 Use My Information?</h3>
      <p>
        We collect, maintain, and use your information for the following
        purposes:
      </p>
      <br />
      <ul>
        <li>
          establishing and verifying the identity and eligibility of users;
        </li>
        <li>
          opening, maintaining, administering, managing, and servicing users
          profiles, accounts or memberships;
        </li>
        <li>
          processing, servicing or enforcing transactions (including credit or
          debit card transactions and gift card transactions);
        </li>
        <li>
          providing products, content, content suggestions, services, and
          support;
        </li>
        <li>
          conducting special events, sweepstakes, surveys, programs, contests,
          and other offers (and communicating with you about such events);
        </li>
        <li>
          analyzing and improving our products, services, or Website (including
          developing new products and services; improving safety; managing our
          communications; analyzing our products; performing market research;
          performing data analytics; and performing accounting, auditing and
          other internal functions);
        </li>
        <li>providing users with product, service, or company updates;</li>
        <li>
          marketing and advertising our products or services as well as products
          and services of third parties (such as affiliates, subsidiaries, and
          business partners);
        </li>
        <li>
          responding to your inquiries or comments, or contacting you as
          necessary;
        </li>
        <li>
          operating and communicating with you about or through external social
          networking platforms;
        </li>
        <li>
          maintaining the security and integrity of our systems, including
          maintaining internal records;
        </li>
        <li>
          conforming to legal requirements or industry standards, complying with
          legal process, detecting and preventing fraud or misuse, defending our
          legal rights, or protecting others;
        </li>
        <li>
          as part of a merger, acquisition, bankruptcy, transfer, sale,
          corporate change, or any other transaction involving all or a portion
          of Life365’s assets
        </li>
      </ul>
      <br />
      <p>
        All information we collect may be aggregated and merged or enhanced with
        data from other sources, such as third parties or our mobile
        application. We may also collect and store information locally on your
        device using mechanisms such as browser web storage (including HTML 5)
        and application data caches.
      </p>
      <br />
      <h3>4. How Does Life365 Share My Information?</h3>
      <p>
        We may disclose your information to third parties who help us with our
        business functions, such as service providers or suppliers. Examples of
        these service providers include entities that process credit card and
        other types of payments, help us moderate content posted on the Website,
        provide web hosting or analytics services, or who assist with marketing
        functions. These service providers may be located around the world and
        in countries where privacy rules are different or less stringent than
        rules in the country where you reside.
      </p>
      <p>
        We may also share your information with affiliated companies and
        subsidiaries as well as with other third parties for our or the third
        party’s marketing purposes and when we believe that their products or
        services may be of interest to you.
      </p>
      <p>
        ​We may also contract with third-party advertising networks that collect
        IP addresses and other information through the use of cookies, web
        server logs and web beacons on our Websites and emails; on third-party
        websites and emails; and on our advertising placed on third-party
        websites.
      </p>
      <p>
        They use this information to provide advertisements about products and
        services tailored to your interests (including for companies not
        affiliated with us). You may see these advertisements on other websites.
        This process also helps us manage and track the effectiveness of our and
        third party marketing efforts. To learn more about these and other
        advertising networks and their opt-out instructions, visit
        http://www.networkadvertising.org/choices/.
      </p>
      <p>
        In addition, we may share your information if necessary to protect the
        safety, property, or other rights of us, our customers, or employees, or
        when otherwise required by law. We may also share your information with
        your consent in certain circumstances.
      </p>
      <p>
        ​We reserve the right to transfer information we have about you in the
        event we sell, transfer, or engage in another transaction involving all
        or a portion of our business or assets, or undertake another form of
        corporate change, including bankruptcy. Following such a sale, transfer,
        or transaction, or corporate change, you may contact the entity to which
        we transferred your information with any inquiries concerning the
        processing of that information.
      </p>
      <p>
        ​Your information may be stored in databases maintained by Life365
        (including local storage) or third parties, and may be disclosed to
        third parties for the purposes stated in this Privacy Statement, that
        are located within and outside the United States, including countries
        where privacy rules differ and may be less stringent than those of the
        country in which you reside. If you visit our Websites from a country
        other than the United States, you consent to such cross-border transfers
        of personal data to the United States and to other countries around the
        world.
      </p>
      <br />
      <h3>​5. What About External Social Media Platforms?</h3>
      <p>
        ​Our Websites’ web pages may embed plugs-ins, widgets or other apps of
        various external social media platforms. When you encounter those
        embedded objects, your internet browser may make a direct connection to
        the social media platform’s service and may share with the social media
        platforms information such as which of our Websites you have visited,
        information about your public profile, or content you have posted.
      </p>
      <br />
      <h3>​6. Is My Information Secure?</h3>
      <p>
        ​Life365 will take reasonable precautions to protect your information
        from loss, misuse or alteration. Please be aware, however, that any
        email or other transmission you send through the Internet cannot be
        completely protected against unauthorized interception.
      </p>
      <br />
      <h3>7. Does Life365 Collect Information From Children?</h3>
      <p>
        Life365 does not intentionally collect information from children under
        13 years of age, and children under age 13 should not submit any
        information to us. If we become aware that a child has provided us with
        information without parental consent, or a parent or guardian of a child
        contacts us through the contact information provided below, we will use
        reasonable efforts to delete the child’s information from our databases.
      </p>
      <br />
      <h3>8. What Choices Do I Have? </h3>
      <p>
        We want to communicate with you about our products and services and make
        content available to you, but only in the ways that you agree to hear
        from us. You may “opt-out,” or unsubscribe from our newsletters, special
        offers or discounts, or other marketing communications by following the
        unsubscribe instructions in any e-mail or other communication you
        receive from us. After doing so, you will not receive future promotional
        emails unless you open a new account, enter a contest, or sign up to
        receive newsletters or emails. You may also continue to receive
        non-marketing communications about your account or purchases that you
        have made. Please allow up to 2 weeks to process your request.
      </p>
      <p>
        We store data for as long as it is necessary to provide the products and
        services described in this Privacy Statement and for our internal
        business purposes. If you would like us to delete information, you may
        contact us using the information below and we will take reasonable
        efforts to delete your information from our records, but may need to
        keep a copy for administrative purposes (such as documenting that a
        transaction occurred).
      </p>
      <p>
        We also participate in interest-based or behavioral advertising. This
        means that you may receive advertising on our website or other websites
        that are tailored to how you browse. Learn more about such advertising,
        including how to opt-out, at http://www.networkadvertising.org/choices/.
      </p>
      <br />
      <h3>
        9. I Live in California – What About My California Privacy Rights?
      </h3>
      <p>
        ​As described in this Privacy Policy, from time to time we may make your
        personal information available to third parties for their own marketing
        purposes. If you do not want us to share your personal information with
        third parties for their marketing purposes, you may opt-out of this
        information sharing by emailing us at support@life365.health.
      </p>
      <br />
      <h3>10. How Can I Contact Life365?</h3>
      <p>
        Life365 is committed to working with consumers to obtain a fair and
        rapid resolution of any queries, complaints, or disputes about privacy.
        If you have submitted information to Life365 and you would like to have
        it deleted from our databases or corrected, or if you have any other
        questions or comments regarding our privacy practices, please email us
        at support@life365.health for more information.
      </p>
      <br />
      <p>Effective Date: July 3, 2016</p>
    </StyledDiv>
  );
}
